import { useTheme } from '@components/theme';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import classNames from 'classnames';
import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => {
  const theme = useTheme();
  const footer = {
    title: 'Let us help you design your space',
    ctaLabel: 'Take our style quiz',
    ctaUrl: '/interior-design-style-quiz',
    overline: 'YOUR PERFECT MATCH',
  };

  return (
    <footer className={classNames(
      styles.Footer,
      theme.styles.Section,
      theme.styles.Core4
    )}
    >
      <div className={theme.styles.Overline}>{footer.overline}</div>
      <img
        className={styles.Image}
        src="/static/images/shop/cta-want-look-avatar.png"
        alt="Avatar"
        height="70"
        width="121"
      />
      <div className={classNames(
        styles.Title,
        theme.styles.Header,
      )}
      >
        {footer.title}
      </div>
      <a
        role="button"
        href={footer.ctaUrl}
        className={classNames(
          theme.styles.Button,
          theme.styles.Conflicting
        )}
        onClick={() => {
          analyticsTrack(
            'cta_clicked', {
              title: `Shop Landing Page | Footer | ${footer.title}`,
              ctaLabel: footer.ctaLabel,
              ctaUrl: footer.ctaUrl
            }
          );
        }}
      >
        {footer.ctaLabel}
      </a>
    </footer>
  );
};

export default Footer;
